export function getScreenProfile() {
  var keys, output;

  if ('undefined' == typeof window || !window.screen) return {};

  keys = [
    'height',
    'width',
    'colorDepth',
    'pixelDepth',
    'availHeight',
    'availWidth'
  ];
  output = {};

  for (var i = 0; i < keys.length; i++) {
    output[keys[i]] = window.screen[keys[i]] ? window.screen[keys[i]] : null;
  }

  output.orientation = {
    angle: window.screen.orientation ? window.screen.orientation['angle'] : 0,
    type: window.innerWidth > window.innerHeight ? 'landscape' : 'portrait'
  };

  return output;
}
